// Site-wide content — links, promos, gallery. Edit here.
export const SITE_URL = "https://www.teadm.com";

export const LINKS = {
  toastHub: "https://teadm.toast.site/",
  giftCards: "https://www.toasttab.com/teadm-fairfax/giftcards",
  rewards: "https://www.toasttab.com/teadm-fairfax/rewardsLookup",
  toastNewsletter: "https://www.toasttab.com/teadm-fairfax/marketing-signup",
  instagram: "https://www.instagram.com/teadmeastcoast/",
  facebook: "https://www.facebook.com/Teadmlounge/",
  email: "teadmlounge@gmail.com",
  popularMenu: "https://irp.cdn-website.com/60e01216/files/uploaded/Teadm+popular+Menu.pdf",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/menu", label: "Menu" },
  { to: "/our-story", label: "Our Story" },
  { to: "/locations", label: "Locations" },
  { to: "/gift-cards", label: "Gift Cards" },
  { to: "/contact", label: "Contact" },
];

export const LOYALTY = { spend: 50, points: 50, reward: "1 free drink" };

export const TOAST_PROMO = { title: "Buy 4, get 1 free", code: "B4G1", note: "Promo shown on the TeaDM Toast ordering site. Terms are set at checkout." };

export const NEW_ITEMS = [
  { name: "TeaDM Popcorn Chicken", where: "Falls Church", image: "/img/new-popcorn-chicken.webp", note: "No spicy, mild or spicy — with sauces like spicy mayo, sweet lime, tomyum and basil aioli." },
  { name: "Eggspresso Over Ice", where: "Falls Church", image: "/img/new-eggspresso.webp", note: "Vietnamese egg coffee, poured over ice." },
];

export const MERCH = [
  { name: "TeaDM Hoodie", image: "/img/merch-hoodie.webp" },
  { name: "TeaDM Black T-shirt", image: "/img/merch-black-tee.webp" },
  { name: "TeaDM White T-shirt", image: "/img/merch-white-tee.webp" },
];

export const CONCEPTS = [
  { name: "Pop-Up District", text: "A vibrant array of food vendors and talented chefs come together to create an unforgettable dining experience, showcasing unique flavors and culinary traditions.", url: "https://popup-district.com/" },
  { name: "The Beat Bakery", text: "An assortment of fresh-baked pastries prepared every day — the first batch comes out of the oven at 10 AM.", url: "https://order.toasttab.com/online/thebeat" },
  { name: "Soulber Pub", text: "A lively pub inside Pop-Up District serving craft cocktails and draft beers, with live DJs and music at night.", url: "https://popup-district.com/" },
];

export const GALLERY = [
  { src: "/img/lineup-flatlay.webp", alt: "A lineup of TeaDM drinks in branded cups, shot from above" },
  { src: "/img/strawberry-milk-tea.webp", alt: "Strawberry milk tea with fresh strawberries on a pink backdrop" },
  { src: "/img/g8.webp", alt: "Lavender-colored TeaDM drink topped with flowers on a purple backdrop" },
  { src: "/img/lineup-store.webp", alt: "TeaDM drinks lined up on the counter inside the store" },
  { src: "/img/g10.webp", alt: "Blue butterfly pea drink with lime and lemon slices on a yellow backdrop" },
  { src: "/img/g7.webp", alt: "Milk being poured into a layered iced tea" },
  { src: "/img/g2.webp", alt: "Layered green and cream drink with cookie crumble topping" },
  { src: "/img/g9.webp", alt: "Golden fruit tea with peach pieces on a bright yellow backdrop" },
  { src: "/img/g3.webp", alt: "Sparkling citrus tea with a lime wedge on a yellow backdrop" },
];

export const FAQ = [
  { q: "What is Tea DM?", a: "Tea DM is a bubble tea shop offering a wide variety of delicious bubble tea flavors and toppings, with four locations in Virginia." },
  { q: "Where are your locations?", a: "Falls Church, Fairfax, Vienna and Sterling, Virginia." },
  { q: "Do you offer online ordering?", a: "Yes! You can place an order through Toast for any of our locations — pick your store from any Order Online button." },
  { q: "Can I host an event at Tea DM?", a: "Yes, we love hosting events! Send us an event inquiry through the contact form for more details about booking." },
  { q: "Do you sell gift cards?", a: "Yes, you can purchase gift cards in-store or online. They make the perfect gift for bubble tea lovers, and they are valid at all locations." },
];
